// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--9-1!../../../node_modules/sass-loader/dist/cjs.js??ref--9-2!./base.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("1098c2f4", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/base.scss
// module id = AMzZ
// module chunks = 38